import { useLocation } from "react-router-dom";
import { useLanguageSchema } from "../../hooks/useLanguageSchema.js";
import { Container } from "../Container/Container.jsx";
import {
  AccentContainer,
  AdditionalContainer,
  Content,
  FooterSection,
  LinkStyled,
} from "./Footer.styled.js";

export const Footer = () => {
  const {
    footer: { title, copyright, button },
  } = useLanguageSchema();
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <FooterSection>
      <AccentContainer>
        <Container>
          <Content>
            <div>
              {title.map((line, index) => (
                <h2 key={index} className="footer-title">
                  {line}
                </h2>
              ))}
            </div>
            {!isHomePage && (
              <div className="button-container">
                <LinkStyled to={"/#contact"} className="footer-button">
                  {button}
                </LinkStyled>
              </div>
            )}
          </Content>
        </Container>
      </AccentContainer>
      <AdditionalContainer>
        <Container>
          <div className="footer-copyright">
            <p>{`© ${new Date().getFullYear()} ${copyright}`}</p>
          </div>
        </Container>
      </AdditionalContainer>
    </FooterSection>
  );
};
